/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { containerStyles } from "../../theme/commonStyle";
import { Theme } from "@mui/material";

const containerBase = {
  ...containerStyles,
  "& h2": {
    marginTop: "0px",
  },
};

const containerStyle = {
  responsiveContainer: (theme: Theme) => ({
    [theme.breakpoints.up("lg")]: {
      maxWidth: "1140px",
    },
    ...containerBase,
  }),
  containerBase: containerBase,
  section: {},
  noSection: {
    paddingTop: 0,
    paddingBottom: 0,
  },
};

export default containerStyle;
